import { render, staticRenderFns } from "./MenuModifiers.vue?vue&type=template&id=6dd4f427&"
import script from "./MenuModifiers.vue?vue&type=script&lang=js&"
export * from "./MenuModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports